<template>
  <div>
    <autocomplete
      v-model="selectedCompanies"
      :items="mealCompanies"
      :label="$t('select_company')"
      item-text="name"
      item-value="id"
      selectable-all
      clearable
      :loading="isLoading"
      chips
      return-object
      deletable-chips
      multiple
      prepend-item
      :label-min-selected="device.isMobile ? 2 : 5"
    >
      <template v-slot:prepend-item>
        <v-list-item
          @click="toggleAllCompanies"
          style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)"
        >
          <v-list-item-action>
            <v-checkbox
              :value="selectedCompanies.length === mealCompanies.length"
            ></v-checkbox>
          </v-list-item-action>
          <v-list-item-title>
            {{ $t("display_all") }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </autocomplete>
  </div>
</template>

<script>
export default {
  methods: {
    toggleAllCompanies() {
      if (this.selectedCompanies.length) {
        this.selectedCompanies = [];
      } else {
        this.selectedCompanies = this.mealCompanies;
      }
    },
    fetchMealCompanies() {
      this.$store
        .dispatch("report/fetchMealCompanies", {
          date_from: this.filters.dates.from,
          date_to: this.filters.dates.to,
          restaurant_id: this.restaurantId,
        })
        .then(() => {
          if (this.mealCompanies && this.mealCompanies.length) {
            this.selectedCompanies = [this.mealCompanies[0]];
          }
        });
    },
  },
  computed: {
    isLoading() {
      return this.$store.getters["report/isLoading"]("fetchMealCompanies");
    },
    mealCompanies() {
      let companies = (this.$store.state.report.mealCompanies || []).map((company) => ({
        ...company,
        name: this.toLatin(company.name || company.company || ""),
      }));

      return companies;
    },
    selectedCompanies: {
      get() {
        return this.$store.state.report.selectedMealCompanies;
      },
      set(val) {
        this.$store.commit("report/SET_SELECTED_MEAL_COMPANIES", val);
      },
    },
    selectedCompaniesProxy: {
      get() {
        return this.selectedCompanies;
      },
      set(val) {
        this.selectedCompanies = val;
      },
    },
    filters() {
      return this.$store.state.report.filters;
    },
    restaurantId() {
      return this.$store.state.restaurant.id;
    },
  },
  watch: {
    restaurantId: {
      handler(newVal) {
        if (this.mealCompanies.length || !newVal) return;
        this.fetchMealCompanies();
      },
      immediate: true,
    },
  },
};
</script>
